<template>
  <div class="swiper-box">
    <swiper :options="swiperOption" id="swiper-parent">
      <swiper-slide>
        <div :style="{height:fullHeight + 'px'}" class="index-box-1">
          <!-- <img src="@/assets/imgs/bg-index-1.jpg" class="bg"> -->
          <h-navigation></h-navigation>
          <div class="top-div">
            <img src="@/assets/imgs/content-index-1.png">
            <!-- <p>顺恒融丰供应链科技有限公司</p>
            <p>依托顺丰集团资源为基础，致力发展科技实力，坚持自主创新，整合业界一流的科研能力，将大数据、移动互联网、区块链、云计算、神经网络等技术与工具引入产品及服务流程，协助企业合作伙伴进入智能化、数字化的新时代，为企业合作伙伴及产业链上下游提供以科技赋能、科技创新为手段的信息化系统与数字化服务解决方案。</p> -->
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div :style="{height:fullHeight + 'px'}" class="index-box-2">
          <!-- <img src="@/assets/imgs/bg-index-2.jpg" class="bg"> -->
          <img src="@/assets/imgs/content-index-2.png" class="txt-img" @click="goGuide('dig')">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div :style="{height:fullHeight + 'px'}" class="index-box-3">
          <!-- <img src="@/assets/imgs/bg-index-3.jpg" class="bg"> -->
          <img src="@/assets/imgs/content-index-3.png" class="txt-img" @click="goGuide('info')">
        </div>
      </swiper-slide>
      <swiper-slide>
        <f-navigation></f-navigation>
        <!-- <div :style="{height:footHeight + 'px'}" class="sel-4"> -->

      </swiper-slide>
      <div class="swiper-pagination"  slot="pagination"></div>   <!-- 分页 -->
      <div class="swiper-pagination"  slot="pagination"></div>   <!-- 分页 -->
      <div class="swiper-pagination"  slot="pagination"></div>   <!-- 分页 -->
      <div class="swiper-pagination"  slot="pagination"></div>   <!-- 分页 -->

    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import HNavigation from '@/components/HNavigation'
import FNavigation from '@/components/FNavigation'
export default {
  components: {
    swiper,
    swiperSlide,
    HNavigation,
    FNavigation
  },
  data () {
    return {
      fullHeight: 0,
      footHeight: 0,
      // 设置属性
      swiperOption: {
        autoplay: false,
        loop: false,
        direction: 'vertical',
        slidesPerView: 'auto',
        speed: 1200,
        grabCursor: false,
        initialSlide: 0,
        // 开启鼠标滚轮控制Swiper切换
        mousewheel: true,
        mousewheelControl: true,
        mousewheelReleaseOnEdges: true,
        autoHeight: true,
        resistanceRatio: 0, // 抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        // height: window.innerHeight,
        on: {
          slideChangeTransitionStart: function () {
            console.log(this.realIndex)
          },
          slideChangeTransitionEnd: function () {}
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许分页点击跳转
        },
        spaceBetween: -1,
        observer: true,
        observeParents: true
      }
    }
  },
  created () {
    this.showHomeHeader = false
    // this.$store.commit('setPublickShow', false)
    console.log(window.innerHeight)
    this.fullHeight = window.innerHeight + 3
    // this.footHeight = window.innerHeight / 3.2
  },
  activated () {
    console.log('activated')
  },
  methods: {
    goGuide (hashName) {
      this.$router.push(`/${hashName}`)
    }
  }
}
</script>
<style scoped lang="scss">
.swiper-container-vertical>.swiper-pagination-bullets {
  right: 40px;
}
#swiper-parent /deep/ .swiper-pagination-bullet{
  width: 8px;
  height: 8px;
  background: #87b9eb;
  border: 1px solid #87b9eb;
  margin: 12px 0;
}
#swiper-parent /deep/ .swiper-pagination-bullet-active {
  width: 10px;
  height: 10px;
  background: transparent;
}
.swiper-box{
  // min-width: 1100px;
  // max-width: 1920px;
  width: 100%;
  // height: 770px;
  // margin: 20px auto;
  .swiper-container{
    // height: 100%;
  }
  .swiper-slide{
    // height: 100%;
    >.index-box-1{
      position: relative;
      background: url('../assets/imgs/bg-index-1.jpg') no-repeat;
      background-size: 100% 100%;
      width: 100%;
      >.top-div{
        width: 1080px;
        max-width: 74%;
        display: inline-block;
        text-align: left;
        position: relative;
        // padding-top: 20%;
        height: 100%;
        >img{
          max-width: 70%;
          max-height: 80%;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
        }
        >p{
          text-align: left;
          &:first-of-type{
            font-family: SourceHanSansCN-Medium;
            font-size: 60px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
          }
          &:last-of-type{
            margin-top: 22px;
            max-width: 592px;
            display: inline-block;
            font-family: SourceHanSansCN-Regular;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
          }
          /* height: 247px; */
          // position: absolute;
          // top: 0;
          // left: 0;
          // right: 0;
          // bottom: 0;
          // margin: auto 0;
        }
      }
    }
    >.index-box-2{
      background: url('../assets/imgs/bg-index-2.jpg') no-repeat;
      background-size: 100% 100%;
      >img{
        max-height: 95%;
        // max-width: 1080px;
        max-width: 74%;
      }
    }
    >.index-box-3{
      background: url('../assets/imgs/bg-index-3.jpg') no-repeat;
      background-size: 100% 100%;
      >img{
        // max-width: 66%;
        max-height: 95%;
        // max-width: 1080px;
        max-width: 74%;
      }
    }
    >div{
      // height: 721px;
      // line-height: 100%;
      overflow: hidden;
      position: relative;
      // width: 100%;
      box-sizing: border-box;
      // background: #fff;
      text-align: center;
      // background-image: url('@/assets/imgs/bg-index-1.jpg');
      border-bottom: 1px solid #e5e5e5;
      >.bg{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
      }
      >.txt-img{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        // height: 80%;
        &:hover{
          cursor: pointer;
        }
      }
      .txt-img-top{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto 0;
        z-index: 1;
        // width: 555px;
        // max-width: 42%;
        // max-height: 80%;
        // width: 1080px;
      }
    }
    // >.sel-4{
    //   // height: 202px;
    //   border: 1px solid #192439;
    //   padding: 0 19%;
    //   background: #192439;
    //   text-align: center;
    //   color: #fff;
    //   .box-1{
    //     text-align: left;
    //     font-size: 18px;
    //     color: #677082;
    //     padding: 40px 0 0;
    //     >.logo{
    //       width: 30px;
    //       // height: 30px;
    //       vertical-align: middle;
    //     }
    //     >span{
    //       font-family: SourceHanSansCN-Regular;
    //       margin-left: 10px;
    //     }
    //     >a{
    //       color: #677082;
    //       font-family: SourceHanSansCN-Regular;
    //       margin-left: 10px;
    //     }
    //     .link{
    //       font-size: 14px;
    //     }
    //   }
    //   .box-2{
    //     width: 100%;
    //     padding: 34px 0;
    //     border-bottom: solid #2e394e 1px;
    //     td{
    //       width: 25%;
    //       >img{
    //         width: 102px;
    //       }
    //     }
    //     .td1{
    //       text-align: left;
    //       width: 20%;
    //     }
    //     .td4{
    //       text-align: right;
    //       width: 20%;
    //     }
    //     .td2{
    //       text-align: center;
    //       width: 30%;
    //     }
    //     .td3{
    //       text-align: center;
    //       width: 20%;
    //     }
    //   }
    //   .box-3{
    //     padding: 28px 0 32px;
    //     a{
    //       color: #444e62;
    //       font-size: 14px;
    //       text-align: center;
    //       &:first-child{
    //         margin-bottom: 14px;
    //       }
    //       &:last-of-type{
    //         font-size: 10px;
    //       }
    //     }
    //     img{
    //       width: 30px;
    //     }
    //   }
    //   // >img{
    //   //   max-width: 55%;
    //   //   max-height: 80%;
    //   // }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue